import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api from './api';

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=anon, obj=user
  const [checked, setChecked] = useState(false);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem('gf_token');
    if (!token) {
      setUser(false);
      setChecked(true);
      return;
    }
    try {
      const { data } = await api.get('/auth/me');
      setUser(data.user);
    } catch {
      localStorage.removeItem('gf_token');
      setUser(false);
    } finally {
      setChecked(true);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = (token, u) => {
    localStorage.setItem('gf_token', token);
    setUser(u);
  };

  const logout = () => {
    localStorage.removeItem('gf_token');
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, checked, login, logout, refresh, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  return useContext(AuthCtx);
}
